import ProjectsGrid from "../../components/disposables/Grid";
import { GridItemProps } from "../../components/disposables/Grid/GridItem";
import Layout from "../../layout/Layout";
import { RaftTypeE } from "../../types/raft";
import styles from "./styles.module.css";
import { useEffect } from "react";

import GameIcon from "../../assets/nav-buttons/games.svg";
import GameIconHovered from "../../assets/nav-buttons/games-hovered.svg";

import LessonIcon from "../../assets/nav-buttons/lessons.svg";
import LessonIconHovered from "../../assets/nav-buttons/lessons-hovered.svg";
import { VisitedScreenEnum } from "@robotical/appv2-analytics-gatherer/dist/types/types";
import { useTranslation } from "react-i18next";

const loggingActivityVisit = (activityId: string) => {
  window.applicationManager.AnalyticsFacade.logActivityVisit(activityId);
  return true; // Allow navigation
}


const imageStyle: React.CSSProperties = {
  width: "80%",
  height: "70%",
  alignSelf: "center",
  justifySelf: "center",
};

const imageX = "10%";
const imageY = "15%";

const gamesGridContent: GridItemProps[] = [

];

const lessonsGridContent: GridItemProps[] = [
  {
    type: "heading",
    title: "activities.cog_blocks_jr_activities_heading",
    contentTags: [RaftTypeE.COG],
    tags: ["Cog", "Blocks Jr"]
  },
  {
    title: "activities.make_a_tune_title",
    subtitle: 'activities.make_a_tune_subtitle',
    href: "/blocks-jr?tutorial=cog-jrblocks-1",
    contentTags: [RaftTypeE.COG],
    type: "lesson",
    tags: ["Cog", "Blocks Jr"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    beforeNavigationCallback: () => loggingActivityVisit("cog-jrblocks-1"),
  },
  {
    title: "activities.make_a_light_show_title",
    subtitle: 'activities.make_a_light_show_subtitle',
    href: "/blocks-jr?tutorial=cog-jrblocks-2",
    contentTags: [RaftTypeE.COG],
    type: "lesson",
    tags: ["Cog", "Blocks Jr"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    beforeNavigationCallback: () => loggingActivityVisit("cog-jrblocks-2"),
  },
  {
    title: "activities.make_a_sound_light_show_title",
    subtitle: 'activities.make_a_sound_light_show_subtitle',
    href: "/blocks-jr?tutorial=cog-jrblocks-3",
    contentTags: [RaftTypeE.COG],
    type: "lesson",
    tags: ["Cog", "Blocks Jr"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    beforeNavigationCallback: () => loggingActivityVisit("cog-jrblocks-3"),
  },
  {
    title: "activities.make_an_etch_a_sketch_title",
    subtitle: 'activities.make_an_etch_a_sketch_subtitle',
    href: "/blocks-jr?tutorial=cog-jrblocks-4",
    contentTags: [RaftTypeE.COG],
    type: "lesson",
    tags: ["Cog", "Blocks Jr"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    beforeNavigationCallback: () => loggingActivityVisit("cog-jrblocks-4"),
  },
  {
    title: "activities.make_a_maze_game_title",
    subtitle: 'activities.make_a_maze_game_subtitle',
    href: "/blocks-jr?tutorial=cog-jrblocks-5",
    contentTags: [RaftTypeE.COG],
    type: "lesson",
    tags: ["Cog", "Blocks Jr"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    beforeNavigationCallback: () => loggingActivityVisit("cog-jrblocks-5"),
  },
  {
    title: "activities.parking_sensor_title",
    subtitle: 'activities.parking_sensor_subtitle',
    href: "/blocks-jr?tutorial=cog-jrblocks-6",
    contentTags: [RaftTypeE.COG],
    type: "lesson",
    tags: ["Cog", "Blocks Jr"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    beforeNavigationCallback: () => loggingActivityVisit("cog-jrblocks-6"),
  },
  {
    title: "activities.lets_get_counting_title",
    subtitle: 'activities.lets_get_counting_subtitle',
    href: "/blocks-jr?tutorial=cog-jrblocks-7",
    contentTags: [RaftTypeE.COG],
    type: "lesson",
    tags: ["Cog", "Blocks Jr"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    beforeNavigationCallback: () => loggingActivityVisit("cog-jrblocks-7"),
  },
  {
    title: "activities.make_a_night_light_title",
    subtitle: 'activities.make_a_night_light_subtitle',
    href: "/blocks-jr?tutorial=cog-jrblocks-8",
    contentTags: [RaftTypeE.COG],
    type: "lesson",
    tags: ["Cog", "Blocks Jr"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    beforeNavigationCallback: () => loggingActivityVisit("cog-jrblocks-8"),
  },
  {
    title: "activities.dodgeball_game_title",
    subtitle: 'activities.dodgeball_game_subtitle',
    href: "/blocks-jr?tutorial=cog-jrblocks-9",
    contentTags: [RaftTypeE.COG],
    type: "lesson",
    tags: ["Cog", "Blocks Jr"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    beforeNavigationCallback: () => loggingActivityVisit("cog-jrblocks-9"),
  },
  {
    title: "activities.make_shapes_with_marty_title",
    subtitle: 'activities.make_shapes_with_marty_subtitle',
    href: "/blocks-jr?tutorial=cog-jrblocks-10",
    contentTags: [RaftTypeE.COG],
    type: "lesson",
    tags: ["Cog", "Blocks Jr"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    beforeNavigationCallback: () => loggingActivityVisit("cog-jrblocks-10"),
  },
  {
    title: "activities.space_game_title",
    subtitle: 'activities.space_game_subtitle',
    href: "/blocks-jr?tutorial=cog-jrblocks-11",
    contentTags: [RaftTypeE.COG],
    type: "lesson",
    tags: ["Cog", "Blocks Jr"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    beforeNavigationCallback: () => loggingActivityVisit("cog-jrblocks-11"),
  },
  {
    title: "activities.reaction_test_title",
    subtitle: 'activities.reaction_test_subtitle',
    href: "/blocks-jr?tutorial=cog-jrblocks-12",
    contentTags: [RaftTypeE.COG],
    type: "lesson",
    tags: ["Cog", "Blocks Jr"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    beforeNavigationCallback: () => loggingActivityVisit("cog-jrblocks-12"),
  },
  {
    title: "activities.adventure_story_title",
    subtitle: 'activities.adventure_story_subtitle',
    href: "/blocks-jr?tutorial=cog-jrblocks-13",
    contentTags: [RaftTypeE.COG],
    type: "lesson",
    tags: ["Cog", "Blocks Jr"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    beforeNavigationCallback: () => loggingActivityVisit("cog-jrblocks-13"),
  },

  {
    type: "heading",
    title: "activities.cog_blocks_activities_heading",
    contentTags: [RaftTypeE.COG],
    tags: ["Cog", "Blocks"]
  },
  {
    title: "activities.blocks_cog_sound_lights_tutorial_title",
    subtitle: 'activities.blocks_cog_sound_lights_tutorial_subtitle',
    href: "/blocks?tutorial=cog-blocks-1",
    contentTags: [RaftTypeE.COG],
    type: "lesson",
    tags: ["Cog", "Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    beforeNavigationCallback: () => loggingActivityVisit("cog-blocks-1"),
  },


  {
    type: "heading",
    title: "activities.using_cog_marty_together_heading",
    contentTags: [RaftTypeE.COG],
    tags: ["Cog", "Blocks Jr"]
  },
  {
    title: "activities.cog_marty_blocks_jr_tutorial_title",
    subtitle: "activities.cog_marty_blocks_jr_tutorial_subtitle",
    href: "/blocks-jr?tutorial=cog-and-marty-tutorial",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Cog", "Marty", "Blocks Jr"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    beforeNavigationCallback: () => loggingActivityVisit("cog-and-marty-blocksjr-tutorial"),
  },

  {
    title: "activities.blocks_tutorial_title",
    subtitle: "activities.blocks_tutorial_subtitle",
    href: "/blocks?tutorial=cog-and-marty-interaction",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Cog", "Marty", "Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    beforeNavigationCallback: () => loggingActivityVisit("cog-and-marty-blocks-tutorial"),
  },
];

const gamesGridContentComingSoon: GridItemProps[] = [
  {
    type: "game",
    title: "Helicopter Marty", subtitle: "Fly Marty through obstacles!", contentTags: [RaftTypeE.MARTY], href: '',
    SvgIcon: () => <image x={imageX} y={imageY} href={GameIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={GameIconHovered} style={imageStyle} />,
    tags: ["Marty"],
    isComingSoon: true
  },
  {
    type: "game",
    title: "Marty Goes Skiing", subtitle: "Hit the slopes with Marty!", contentTags: [RaftTypeE.MARTY], href: '',
    SvgIcon: () => <image x={imageX} y={imageY} href={GameIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={GameIconHovered} style={imageStyle} />,
    tags: ["Marty"],
    isComingSoon: true
  },
  {
    type: "game",
    title: "Lighting Designer", subtitle: "Create stunning lighting effects!", contentTags: [RaftTypeE.MARTY, RaftTypeE.COG], href: '',
    SvgIcon: () => <image x={imageX} y={imageY} href={GameIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={GameIconHovered} style={imageStyle} />,
    tags: ["Cog", "Marty"],
    isComingSoon: true
  },
  {
    type: "game",
    title: "Reaction Test Game", subtitle: "Test your reaction speed!", contentTags: [RaftTypeE.MARTY, RaftTypeE.COG], href: '',
    SvgIcon: () => <image x={imageX} y={imageY} href={GameIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={GameIconHovered} style={imageStyle} />,
    tags: ["Cog", "Marty"],
    isComingSoon: true
  },
  {
    type: "game",
    title: "Frogger-Style Platformer", subtitle: "Cross the road safely!", contentTags: [RaftTypeE.MARTY, RaftTypeE.COG], href: '',
    SvgIcon: () => <image x={imageX} y={imageY} href={GameIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={GameIconHovered} style={imageStyle} />,
    tags: ["Cog", "Marty"],
    isComingSoon: true
  },
  {
    type: "game",
    title: "Tambourine Rhythm Game", subtitle: "Follow the rhythm!", contentTags: [RaftTypeE.MARTY, RaftTypeE.COG], href: '',
    SvgIcon: () => <image x={imageX} y={imageY} href={GameIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={GameIconHovered} style={imageStyle} />,
    tags: ["Cog", "Marty"],
    isComingSoon: true
  },
  {
    type: "game",
    title: "Group Work - Cog Grid Screen", subtitle: "Collaborate using the cog grid!", contentTags: [RaftTypeE.COG], href: '',
    SvgIcon: () => <image x={imageX} y={imageY} href={GameIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={GameIconHovered} style={imageStyle} />,
    tags: ["Cog"],
    isComingSoon: true
  },
  {
    type: "game",
    title: "Play Notes", subtitle: "Make music with your notes!", contentTags: [RaftTypeE.COG], href: '',
    SvgIcon: () => <image x={imageX} y={imageY} href={GameIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={GameIconHovered} style={imageStyle} />,
    tags: ["Cog"],
    isComingSoon: true
  },
  {
    type: "game",
    title: "Code Wheel - Burglar Alarm", subtitle: "Protect your assets!", contentTags: [RaftTypeE.COG], href: '',
    SvgIcon: () => <image x={imageX} y={imageY} href={GameIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={GameIconHovered} style={imageStyle} />,
    tags: ["Cog"],
    isComingSoon: true
  },
  {
    type: "game",
    title: "Code Wheel - Special Effects", subtitle: "Create amazing effects!", contentTags: [RaftTypeE.COG], href: '',
    SvgIcon: () => <image x={imageX} y={imageY} href={GameIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={GameIconHovered} style={imageStyle} />,
    tags: ["Cog"],
    isComingSoon: true
  },
  {
    type: "game",
    title: "Code Wheel Challenge Mode", subtitle: "Put your skills to the test!", contentTags: [RaftTypeE.COG], href: '',
    SvgIcon: () => <image x={imageX} y={imageY} href={GameIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={GameIconHovered} style={imageStyle} />,
    tags: ["Cog"],
    isComingSoon: true
  }
];

const lessonsGridContentComingSoon: GridItemProps[] = [
  {
    title: "Group work - whole class orchestra",
    subtitle: "Collaborate to make an orchestra!",
    href: "",
    contentTags: [RaftTypeE.COG],
    type: "lesson",
    tags: ["Blocks Jr"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },
  {
    title: "Group work - Cog grid screen animation",
    subtitle: "Collaborate to make an animation with Cog",
    href: "",
    contentTags: [RaftTypeE.COG],
    type: "lesson",
    tags: ["Blocks Jr"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },

  {
    title: "Group work - traffic lights",
    subtitle: "Learn how to create a traffic light system",
    href: "",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },
  {
    title: "Cogs reacting to each other",
    subtitle: "Explore how cogs can interact with each other",
    href: "",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },
  {
    title: "Reaction test game",
    subtitle: "Build a fun reaction test game",
    href: "",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },
  {
    title: "Dice",
    subtitle: "Create a digital dice roller",
    href: "",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },
  {
    title: "Spirit level",
    subtitle: "Build a functional spirit level",
    href: "",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },
  {
    title: "Make a game - skiing game",
    subtitle: "Design and develop a skiing game",
    href: "",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },
  {
    title: "Musical instrument",
    subtitle: "Create your own musical instrument",
    href: "",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },
  {
    title: "Fancy clock",
    subtitle: "Make a stylish and functional clock",
    href: "",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },
  {
    title: "Trundle wheel",
    subtitle: "Build a trundle wheel for measuring distance",
    href: "",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },
  {
    title: "Reactive light show",
    subtitle: "Create an interactive light show",
    href: "",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },
  {
    title: "PE circuit / lap timer / speed challenge",
    subtitle: "Measure speed and laps in physical exercises",
    href: "",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },
  {
    title: "Make a game - Double cog rhythm game",
    subtitle: "Create a fun double cog rhythm game",
    href: "",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },
  {
    title: "Small group work - quiz game",
    subtitle: "Develop an engaging quiz game",
    href: "",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },
  {
    title: "Motion tracker",
    subtitle: "Build a motion tracking system",
    href: "",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },
  {
    title: "ML gesture sensing",
    subtitle: "Implement machine learning for gesture sensing",
    href: "",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  },
  {
    title: "Student project",
    subtitle: "Create your own project with Cog and Marty",
    href: "",
    contentTags: [RaftTypeE.COG, RaftTypeE.MARTY],
    type: "lesson",
    tags: ["Blocks"],
    SvgIcon: () => <image x={imageX} y={imageY} href={LessonIcon} style={imageStyle} />,
    SvgIconOnHover: () => <image x={imageX} y={imageY} href={LessonIconHovered} style={imageStyle} />,
    isComingSoon: true
  }
];

function ActivitiesScreen() {
  const { t } = useTranslation();

  const translatedLessons = lessonsGridContent.map(item => ({
    ...item,
    title: t(item.title),
    subtitle: item.subtitle ? t(item.subtitle) : undefined,
  }));


  useEffect(() => {
    let stopHeartbeat: (() => void) | null = null;
    const logVisit = async () => {
      stopHeartbeat = await window.applicationManager.AnalyticsFacade.logScreenVisit(VisitedScreenEnum.ACTIVITIES);
    };
    logVisit();
    return () => {
      if (stopHeartbeat) {
        stopHeartbeat();
      }
      window.applicationManager.AnalyticsFacade.stopAllActivityHeartbeats();
    };
  }, []);

  return (
    <Layout>
      <div className={styles.projectsSectionContainer}>
        <ProjectsGrid projects={[...gamesGridContent, ...translatedLessons]} comingSoonProjects={[...gamesGridContentComingSoon, ...lessonsGridContentComingSoon]} />
      </div>
    </Layout>
  );
}

export default ActivitiesScreen;
